module.exports = __webpack_public_path__ + "img/btnIos.ede2c0cd.jpeg";